import React, { Component } from "react";
import { Form, Input, Button } from "antd";

const FormItem = Form.Item;

const ClientCreateForm = Form.create()(
  class extends Component {
    render() {
      const { handleSubmit, form, loading } = this.props;
      const { getFieldDecorator } = form;
      return (
        <Form onSubmit={e => handleSubmit(e, form)}>
          <FormItem label="First Name">
            {getFieldDecorator("firstName", {
              rules: [{ required: true }]
            })(<Input />)}
          </FormItem>
          <FormItem label="Last Name">
            {getFieldDecorator("lastName", {
              rules: [{ required: true }]
            })(<Input />)}
          </FormItem>
          <FormItem label="Email Address">
            {getFieldDecorator("email", {
              rules: [{ required: true }]
            })(<Input />)}
          </FormItem>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            loading={loading}
          >
            Continue
          </Button>
        </Form>
      );
    }
  }
);

export { ClientCreateForm };



// WEBPACK FOOTER //
// ./src/components/forms/ClientCreateForm.js